import { render, staticRenderFns } from "./AdminServersList.vue?vue&type=template&id=45898572&scoped=true&"
import script from "./AdminServersList.vue?vue&type=script&lang=js&"
export * from "./AdminServersList.vue?vue&type=script&lang=js&"
import style0 from "./AdminServersList.vue?vue&type=style&index=0&id=45898572&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45898572",
  null
  
)

export default component.exports